import React from "react";
import { Link } from "react-router-dom";
import WorkdocItemInfoModal from "./WorkdocItemInfoModal";
import WorkdocRoles from "./WorkdocRoles";
export default class WorkdocItemInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInfoModal: false,
    };
  }
  renderRoles = () => {
    return (
      <>
        <WorkdocRoles
          openRolesModal={this.props.openRolesModal}
          toggleRolesModal={this.props.toggleRolesModal}
          sourceRole={this.props.sourceRole}
          item={this.props.item}
        />
      </>
    );
  };

  infoModalToggle = (showInfoModal = true) => {
    this.setState({ showInfoModal });
  };

  renderInfo = () => {
    if (!this.props.item) return null;
    let item = this.props.item || {};

    const created = new Date(item.created);
    const lastupdate = new Date(item.lastupdate);
    return (
      <>
        <div
          className="d-inline-block mt-2 mr-3 small  text-primary cursor-pointer text-hover-muted"
          onClick={this.infoModalToggle}
        >
          <i className="fa fa-clock-o mr-2"></i>
          История
        </div>
        {item.parent && (
          <div className="mt-2  mb-3 bg-light p-3">
            <span className="small text-muted mr-2">Основание:</span>
            <Link
              className="text-dark-50 text-hover-primary"
              to={`/workdoc/default/any/${item.parent.id}/`}
            >
              {item.parent.label}
            </Link>
            <span
              onClick={this.props.onRemoveParent}
              className="ml-2 text-muted cursor-pointer text-hover-danger"
            >
              <i className="fa fa-times" title="Не отвечать"></i>
            </span>
          </div>
        )}
        {item.created && (
          <div className="d-inline-block mt-2 mr-5  text-dark-50">
            <span className="small text-muted mr-2">Создан:</span>
            {created.toLocaleString()}
          </div>
        )}
        {item.lastupdate && (
          <div className="d-inline-block mt-2 mr-5  text-dark-50">
            <span className="small text-muted mr-2">Изменен:</span>
            {lastupdate.toLocaleString()}
          </div>
        )}
        <br />

        {item.structurename && (
          <div className="d-inline-block mt-2 mr-5 text-dark-50">
            <span className="small text-muted mr-2">В структуре:</span>
            {item.structurename}
          </div>
        )}
        {item.approvername && (
          <div className="d-inline-block mt-2 mr-5  text-dark-50">
            <span className="small text-muted mr-2">Утвердил:</span>
            {item.approvername}
          </div>
        )}
        {item.executorname && (
          <div className="d-inline-block mt-2 mr-5  text-dark-50">
            <span className="small text-muted mr-2">Исполнитель:</span>
            {item.executorname}
          </div>
        )}
        {item.ownername && (
          <div className="d-inline-block mt-2 mr-5  text-dark-50">
            <span className="small text-muted mr-2">Автор:</span>
            {item.ownername}
          </div>
        )}
        {item.areaname && (
          <div className="d-inline-block mt-2 mr-5  text-dark-50">
            <span className="small text-muted mr-2">Подразделение:</span>
            {item.areaname}
          </div>
        )}
      </>
    );
  };
  render() {
    return (
      <>
        {this.state.showInfoModal && (
          <WorkdocItemInfoModal
            item={this.props.item}
            onClose={() => this.infoModalToggle(false)}
          />
        )}
        {this.renderInfo()}
        <div className="mt-4">{this.renderRoles()}</div>
      </>
    );
  }
}
